import type { SandboxStatus } from "../types";

interface Props {
  status: SandboxStatus;
  size?: "sm" | "md";
}

const TOKENS: Record<
  SandboxStatus,
  { label: string; dot: string; text: string; bg: string; border: string }
> = {
  provisioning: {
    label: "provisioning",
    dot: "bg-phosphor-400 animate-pulse-slow",
    text: "text-phosphor-300",
    bg: "bg-phosphor-800/20",
    border: "border-phosphor-700/60",
  },
  ready: {
    label: "ready",
    dot: "bg-signal-400 shadow-[0_0_6px_var(--color-signal-500)]",
    text: "text-signal-400",
    bg: "bg-signal-950/40",
    border: "border-signal-900",
  },
  failed: {
    label: "failed",
    dot: "bg-danger-500",
    text: "text-danger-400",
    bg: "bg-danger-900/30",
    border: "border-danger-900",
  },
  destroyed: {
    label: "destroyed",
    dot: "bg-ink-400",
    text: "text-ink-300",
    bg: "bg-ink-800/60",
    border: "border-ink-700",
  },
};

export function StatusBadge({ status, size = "sm" }: Props) {
  const t = TOKENS[status];
  const padding = size === "sm" ? "px-2 py-0.5" : "px-3 py-1";
  const textSize = size === "sm" ? "text-[10px]" : "text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${padding} ${textSize} ${t.text} ${t.bg} border ${t.border} uppercase tracking-widest font-medium`}
    >
      <span className={`block w-1.5 h-1.5 ${t.dot}`} />
      {t.label}
    </span>
  );
}
